import React from 'react';
import { TextField } from 'formik-mui';
import { FormControl } from '@mui/material';
import { Field, useFormikContext } from 'formik';

import { ImageAttachments } from '../../ImageAttachments';

const FormTextField = ({
    data,
    handleBlur,
    fieldValues,
    inGroup = false,
    isReadOnly = false,
    isSubmitAllow = true,
    handleClick = () => {},
}) => {
    const { setFieldValue, errors } = useFormikContext();
    const displayLabel = data.display_label_beside_field === true;

    const textFieldData = (
        <FormControl
            style={{
                padding: '5px',
                width: data?.field_width ? data.field_width + '%' : '100%',
            }}
        >
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                }}
            >
                {data?.hide_label !== true && displayLabel && <label>{data?.label}&nbsp;</label>}
                <Field
                    id={data.variable}
                    component={TextField}
                    disabled={!isSubmitAllow}
                    sx={{
                        '& .MuiInputBase-input.Mui-disabled': {
                            WebkitTextFillColor: '#000000',
                        },
                    }}
                    margin="dense"
                    variant="outlined"
                    style={{ width: data.width ? `${data.width}%` : '100%' }}
                    type={data.password ? 'password' : 'text'}
                    name={data.variable}
                    onBlur={() => isSubmitAllow && handleBlur(fieldValues)}
                    onClick={(e) => {
                        if (!isSubmitAllow) {
                            e.stopPropagation();
                            handleClick(e, data);
                        }
                    }}
                    onChange={(e) => {
                        if (isSubmitAllow) {
                            setFieldValue(data.variable, e.target.value);
                        }
                    }}
                    placeholder={data.hide_label || displayLabel || isReadOnly ? '' : data?.label}
                    label={data.hide_label || displayLabel || isReadOnly ? '' : data?.label}
                    error={!!errors?.[data.variable]}
                    helperText={errors?.[data.variable]}
                />
                {data.image_attachments_allow && (
                    <ImageAttachments
                        data={data}
                        var_name={data.variable}
                        level="field"
                        isReadOnly={!isSubmitAllow}
                        handleClick={handleClick}
                    />
                )}
            </div>
        </FormControl>
    );

    return inGroup ? textFieldData : <div style={{ width: '100%' }}>{textFieldData}</div>;
};

export default FormTextField;
